module.exports = __webpack_public_path__ + "static/media/km.a45f5d0e.svg";